module.exports = __webpack_public_path__ + "img/right-info-open-light03.01885f63.png";